import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BulkReassignResultEntity } from '../../../domain/entities/bulk-reassign-result.entity';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { BulkReassignCasesCommand } from './bulk-reassign-cases.command';

@Injectable({ providedIn: 'root' })
export class BulkReassignCasesUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(command: BulkReassignCasesCommand): Observable<BulkReassignResultEntity> {
    return this._repository.bulkReassign({
      caseIds: command.caseIds,
      newPrimaryUserId: command.newPrimaryUserId,
      reason: command.reason,
    });
  }
}
